module.exports = __webpack_public_path__ + "img/defaultPoiImg.b7e827d6.png";